import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import "./style.scss";

interface NotificationProps {
    children?: React.ReactNode;
    title?: string | React.ReactNode;
    duration?: number;
    variant?: "success" | "warning" | "error" | "info";
    onClose: () => void;
}

const Notification = (props: NotificationProps) => {
    useEffect(() => {
        let timer1 = setTimeout(() => props.onClose(), props.duration);

        return () => {
            clearTimeout(timer1);
        };
    }, [props]);

    let icon: IconName = "info-circle";
    switch (props.variant) {
        case "success":
            icon = "check-circle";
            break;
        case "warning":
            icon = "exclamation-circle";
            break;
        case "error":
            icon = "minus-circle";
            break;
        default:
            break;
    }

    return (
        <div className={`vapor-notification ${props.variant}`}>
            <div className="vapor-notification-content">
                <div className="vapor-notification-content-icon">
                    <FontAwesomeIcon icon={["fas", icon]} />
                </div>
                <div className="vapor-notification-content-text">
                    <div className="vapor-notification-content-text-title">
                        {props.title}
                        {props.title ? <>:&nbsp;</> : null}
                    </div>
                    <div className="vapor-notification-content-text-message">
                        {props.children}
                    </div>
                </div>
                <div className="vapor-notification-content-closeIcon">
                    <FontAwesomeIcon
                        onClick={() => props.onClose()}
                        icon={["far", "times"]}
                    />
                </div>
            </div>
            <div className="vapor-notification-footer"></div>
        </div>
    );
};

Notification.defaultProps = {
    duration: 5000,
    variant: "success",
};

export default Notification;
